var _circle, _path, _path2;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgLanguage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8.5,
  r: 5.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M13.5 8.5c0 .057-.034.191-.281.386-.241.19-.62.383-1.134.554C11.062 9.78 9.618 10 8 10s-3.062-.22-4.085-.56c-.513-.171-.893-.364-1.134-.554C2.534 8.69 2.5 8.557 2.5 8.5s.034-.191.281-.386c.241-.19.62-.383 1.134-.554C4.938 7.22 6.382 7 8 7s3.062.22 4.085.56c.513.171.893.364 1.134.554.247.195.281.329.281.386Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M10.5 8.5c0 1.596-.325 3.016-.826 4.019C9.158 13.552 8.537 14 8 14s-1.158-.448-1.674-1.481C5.825 11.516 5.5 10.096 5.5 8.5s.325-3.016.826-4.019C6.842 3.448 7.463 3 8 3s1.158.448 1.674 1.481c.502 1.003.826 2.423.826 4.019Z"
})));
export default SvgLanguage;